export const defaultFields = [
    'Дата',
    'Номер',
    'Вид страхования',
    'Страхователь',
    'Количество застрахованных',
    'Статус оплаты',
    'Дата начала',
    'Страховая сумма',
    'Премия',
    'КВ, %',
    'КВ, руб',
    'Программа',
];
export const allFields = [
    'Дата',
    'Номер',
    'Вид страхования',
    'Страхователь',
    'Количество застрахованных',
    'Статус оплаты',
    'Дата начала',
    'Страховая сумма',
    'Премия',
    'КВ, %',
    'КВ, руб',
    'Программа',
];
export const fieldMappings: Record<string, string> = {
    'Дата': 'Date',
    'Номер': 'Number',
    'Вид страхования': 'ProductName ',
    'Страхователь': 'InsurerName',
    'Количество застрахованных': 'InsuredQuantity',
    'Статус оплаты': 'PaymentStatusName',
    'Дата начала': 'StartDate',
    'Страховая сумма': 'InsuranceSum',
    'Премия': 'InsurancePremium',
    'КВ, %': 'CommissionPercent',
    'КВ, руб': 'CommissionSum',
    'Программа': 'InsuranceProgramPrintName',
};